const TOKEN_KEY = 'novelist_access_token';
/** Legacy snapshot from ``GET /auth/me`` — cleared on logout so stale JSON does not linger. */
const LEGACY_ADMIN_ME_KEY = 'novelist_admin_me_v2';

export const getAccessToken = (): string | null => {
  return localStorage.getItem(TOKEN_KEY);
};

export const setAccessToken = (token: string): void => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const clearTokens = (): void => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(LEGACY_ADMIN_ME_KEY);
};
